import { USER_SORT } from 'constants/cloud-admin';

export interface UserSortState {
  sortByColumn: string;
  clicks: number;
}

const initialState: UserSortState = {
  sortByColumn: '',
  clicks: 0,
};

// Action shape is broad at the reducer boundary; fields read per case below.
interface UserSortAction {
  type: string;
  sortByColumn?: string;
  clicks?: number;
}

export function UserSortReducer(
  state: UserSortState = initialState,
  action: UserSortAction,
): UserSortState {
  switch (action.type) {
    case USER_SORT.SORT_BY_COLUMN:
      return { ...state, sortByColumn: action.sortByColumn ?? '', clicks: 1 };
    case USER_SORT.CLEAR_SORT_BY_COLUMN:
      return { ...state, sortByColumn: '', clicks: 0 };
    case USER_SORT.COLUMN_SORT_CLICKS:
      return { ...state, clicks: action.clicks ?? 0 };
    default:
      return state;
  }
}
